import { render, staticRenderFns } from "./JobIdentify.vue?vue&type=template&id=228247c2&scoped=true"
import script from "./JobIdentify.vue?vue&type=script&lang=js"
export * from "./JobIdentify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228247c2",
  null
  
)

export default component.exports